import { render, staticRenderFns } from "./FaqConfig.vue?vue&type=template&id=a05e48c4&"
import script from "./FaqConfig.vue?vue&type=script&lang=js&"
export * from "./FaqConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports